import { useEffect, useState } from 'react';

export default function useAspectRatio(aspectRatio) {
  const [dimensions, setDimensions] = useState(() => {
    const width = window.innerWidth;
    return {
      width,
      height: width / aspectRatio,
    };
  });

  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;
      setDimensions({
        width,
        height: width / aspectRatio,
      });
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [aspectRatio]);

  return dimensions;
}
